/**
 * Lib.Common: v-label directive
 *
 * Generate tooltip and aria-label.
 */


import $device from '../prototype/device';
import $markdown from '../prototype/markdown';
import $tooltip from '../prototype/tooltip';
import { persistent } from '../prototype/tooltip.vue';

let timeout = 0;


function open() {
    const label = this._label;
    if (label && label.msg != null && !persistent) {
        if (timeout) {
            clearTimeout(timeout);
            timeout = 0;
        }
        label.ctx.$tooltip(label.msg, { ...label, anchor: this });
    }
}


function openStop(e) {
    open.call(this);
    e.stopPropagation();
}


function close() {
    timeout = setTimeout(() => {
        $tooltip.close(this);
        timeout = 0;
    }, 500);
}


function bind(el, binding, vnode) {
    const update = !!el._label;
    const mod = binding.modifiers;

    el._label = {
        ctx: vnode.context,
        msg: binding.value,
        tone:
            mod.accent      ? 'accent' :
            mod.positive    ? 'positive' :
            mod.negative    ? 'negative' :
            mod.buy         ? 'buy' :
            mod.hold        ? 'hold' :
            mod.sell        ? 'sell' :
            mod.ok          ? 'ok' :
            mod.warning     ? 'warning' :
            mod.error       ? 'error' :
            mod.important   ? 'important' : void 0,
        appearance:
            mod.pill        ? 'pill' : void 0,
        position:
            mod.top         ? 'top' :
            mod.bottom      ? 'bottom' :
            mod.left        ? 'left' :
            mod.right       ? 'right' : void 0,
        align:
            mod.start       ? 'start' :
            mod.center      ? 'center' :
            mod.end         ? 'end' : void 0,
        persistent:
            mod.persistent,
        onback:
            el._lback,    // v-label-back
        onnext:
            el._lnext,    // v-label-next
        ondone:
            el._ldone     // v-label-done
    };

    if (!update) {
        if (mod.click || (!mod.hover && !$device.hasMouse)) {
            el.addEventListener('click', mod.stop ? openStop : open);
        } else if (mod.hover || !mod.open) {
            el.addEventListener('mouseenter', open);
            if (!mod.persistent) {
                el.addEventListener('mouseleave', close);
            }
        }
    }

    if (binding.value == null) {
        unbind(el);
    } else if (mod.persistent) {
        setTimeout(() => {
            open.call(el);
        }, 30);
    }
}


function unbind(el) {
    if (el._tt) {
        el._tt.close();
    }
}


export default {
    name: 'label',
    directive: {
        bind,
        unbind,
        update: bind
    }
};
